export class RmBudgetRequest{
    id:number
    month:string
    year:string
    count:number
    quantity:number
    isActive: boolean;
    createdAt : Date ;
    createdUser : string;
    updatedAt : Date ;
    updatedUser : string;
    versionFlag : number;
    managerId:number
    
    constructor(
    id:number,
    month:string,
    year:string,
    count:number,
    quantity:number,
    isActive: boolean,
    createdAt : Date ,
    createdUser : string,
    updatedAt : Date ,
    updatedUser : string,
    versionFlag : number,
    managerId:number

    ){
        this.id = id
        this.month = month
        this.year = year
        this.quantity = quantity
        this.count = count
         this.isActive = isActive
        this.createdAt = createdAt
        this.createdUser = createdUser
        this.updatedAt = updatedAt 
        this.updatedUser = updatedUser
        this.versionFlag = versionFlag
        this.managerId = managerId
    }
}